import React from 'react';
import ClampableText from '../../../components/ClampableText';
import ContentCard from '../../../components_profiles/ContentCard';
import { useConnect } from '@lore/query-connect';
import TextContentSection from '../../../components_profiles/TextContentSection';
import MissingField from '../../offer_manage/OfferMissingField';

export default function Description(props) {
  const { offer } = props;

  const activity = useConnect('tag.byId', {
    id: offer.data.activityId
  });

  return (
    <ContentCard className="space-y-4">
      {(offer.data.title || activity.data.name) ? (
        <div className="text-2xl text-cs-gray-900 font-semibold">
          {offer.data.title || activity.data.name}
        </div>
      ) : (
        <MissingField name="Title" />
      )}
      <TextContentSection title="Summary">
        {offer.data.title ? (
          <ClampableText markup>
            {offer.data.description || activity.data.description}
          </ClampableText>
        ) : (
          <MissingField name="Summary" />
        )}
      </TextContentSection>
      {offer.data.audience && (
        <TextContentSection title="Target audience">
          <ClampableText markup>
            {offer.data.audience}
          </ClampableText>
        </TextContentSection>
      )}
      {offer.data.objective && (
        <TextContentSection title="Objective">
          <ClampableText markup>
            {offer.data.objective}
          </ClampableText>
        </TextContentSection>
      )}
    </ContentCard>
  );
};
